// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var AuthenticateStatus;
(function (AuthenticateStatus) {
    AuthenticateStatus["Valid"] = "valid";
    AuthenticateStatus["AccountNotFound"] = "accountNotFound";
    AuthenticateStatus["AccountDisabled"] = "accountDisabled";
    AuthenticateStatus["AccountLocked"] = "accountLocked";
    AuthenticateStatus["PasswordExpired"] = "passwordExpired";
    AuthenticateStatus["ServerError"] = "serverError";
    AuthenticateStatus["UserFound"] = "userFound";
    AuthenticateStatus["NotAuthenticated"] = "notAuthenticated";
    AuthenticateStatus["SessionExpired"] = "sessionExpired";
    AuthenticateStatus["SessionValid"] = "sessionValid";
    AuthenticateStatus["UserMustChangePassword"] = "userMustChangePassword";
})(AuthenticateStatus || (AuthenticateStatus = {}));
//# sourceMappingURL=authenticateStatus.js.map